import { Injectable } from '@angular/core';
import { BaseService } from '@core/service/base.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SourcingConfigService extends BaseService{

  private url = "api/sourcingType";

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(){
    return this.url;
  }
}
